import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "label-text",
  "use": "label-text-usage",
  "viewBox": "0 0 6 7",
  "content": "<symbol viewBox=\"0 0 6 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"label-text\">\n<path d=\"M5.894 3.006V4.238L4.06 4.14L5.068 5.68L4.004 6.296L3.164 4.644L2.324 6.282L1.274 5.68L2.282 4.126L0.434 4.224V3.006L2.282 3.104L1.274 1.55L2.324 0.933999L3.164 2.586L4.004 0.933999L5.068 1.564L4.06 3.104L5.894 3.006Z\" fill=\"#E56060\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol